import { ApplicationConfig, importProvidersFrom, provideZonelessChangeDetection } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { BrowserModule } from '@angular/platform-browser';
import { AirlineLogoIconRegistry } from '@core/services/airline-logo-icon-registry';
import { CoreModule } from '@core/core.module';
import { AppRoutingModule } from './app-routing.module';
import { provideAppStore } from './store.config';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppStore(),
    importProvidersFrom(
      AppRoutingModule,
      BrowserModule,
      /*  */
      CoreModule
    ),
    provideZonelessChangeDetection(),
    // airline logos come from NugiosCore (docs features/flight-catalogue/qa.md R-FC38 ... R-FC42)
    { provide: MatIconRegistry, useClass: AirlineLogoIconRegistry }
  ]
};
